import MdaeChart from "./component";
import {  IChartOptions  } from "devextreme-react/chart";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeChartOptions extends IChartOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeChart;
